import React from 'react';

export default () => (
  <svg
      focusable='false'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width='24'
      height='24'
      viewBox='0 0 24 24'
  >
    <path d='M12.07,15.75h0a.76.76,0,0,1-.58-.22h0L5.61,9.67a.7.7,0,0,1-.21-.45.88.88,0,0,1,0-.16.74.74,0,0,1,.75-.75H18a.75.75,0,0,1,.75.75V9a.72.72,0,0,1-.2.69l-5.86,5.86A.75.75,0,0,1,12.07,15.75Zm0-1.74,4.2-4.2H7.87Z' />
  </svg>
);
